module.exports = __webpack_public_path__ + "img/ShiftShop.26563696.jpeg";